// ─── Collage Element: Ornament ────────────────────────────────
// Renders SVG ornaments from the preset library.
// Supports tinting via customStyle.color.

import React from 'react';
import { getElementFrameStyle } from '../../../lib/utils/collageLayout';
import { ORNAMENTS } from '../../../lib/ornaments';

export default function OrnamentElement({ element, isMobile, skipPositioning }) {
  const style = skipPositioning ? {} : getElementFrameStyle(element.layout, isMobile);
  const cs = element.customStyle || {};
  const color = cs.color || element.color || '#000000';
  const opacity = cs.opacity ?? 1;

  // If it's a custom uploaded ornament (has src), render as image
  if (element.src) {
    return (
      <div style={style} className="select-none">
        <img
          src={element.src}
          alt={element.name || 'ornament'}
          className="w-full h-auto"
          style={{ opacity }}
          loading="lazy"
        />
      </div>
    );
  }

  // Find preset ornament by style ID
  const preset = ORNAMENTS.find(o => o.id === element.style);
  if (!preset) return null;

  // Replace currentColor with actual color for reliable rendering
  const colorizedSvg = preset.svg.replace(/currentColor/g, color);

  return (
    <div style={style} className="select-none">
      <svg
        viewBox={preset.viewBox}
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-auto"
        style={{ opacity }}
        dangerouslySetInnerHTML={{ __html: colorizedSvg }}
      />
    </div>
  );
}
